// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

/**
 * Checks if a client uses PowerReviews Distribution endpoints
 * @returns {Promise<boolean>} - True if client is pwr-distro
 */
const checkIsPwrDistroClient = wrapWithNetworkError(
  function checkIsPwrDistroClient(token: string, clientId: Id) {
    const fetchUrl = getEndpointUrl(`/distribution/status/${clientId}`);
    const fetchOptions = {
      headers: {
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json())
      .then(data => {
        return typeof data === 'boolean'
          ? data
          : Boolean(data.isDistribution || data.is_distribution || data);
      });
  }
);

export default checkIsPwrDistroClient;



// WEBPACK FOOTER //
// ./src/containers/client/distributionApi.js